import styled from 'styled-components';

import { BodilColor } from '~src/branding';

type Props = { checked?: boolean; disabled?: boolean; transitionTime: number };

export const Track = styled.span<Props>(({ checked, disabled, transitionTime }) => ({
  position: 'absolute',
  cursor: !disabled ? 'pointer' : 'inherit',
  zIndex: 1,

  top: 0,
  left: 0,
  right: 0,
  bottom: 0,

  backgroundColor: checked
    ? disabled
      ? BodilColor.ui.action[21]
      : BodilColor.ui.action.default
    : disabled
      ? BodilColor.greyscale[40]
      : BodilColor.greyscale[20],

  borderRadius: '15px',
  transition: `${transitionTime}s`,
}));

export const Circle = styled.div<{ transitionTime: number }>(({ transitionTime }) => ({
  zIndex: 2,
  pointerEvents: 'none',

  position: 'absolute',
  left: '6px',
  bottom: '6px',

  width: '19px',
  height: '19px',
  borderRadius: '100px',

  backgroundColor: BodilColor.base.white,

  transition: `${transitionTime}s`,
}));

export const Input = styled.input({
  [`&:checked + ${Circle}`]: {
    transform: 'translateX(19px)',
  },

  opacity: 0,
  width: 0,
  hight: 0,
});

export const SwitchWrapper = styled.label({
  position: 'relative',
  display: 'inline-block',
  width: '50px',
  height: '31px',
});
